import { Fragment } from 'react';
import { ChallengeApplicationPage } from '../../../types/challenges';
import useIsMobile from '../../../hooks/useIsMobile';
import PictureStackIcon from '../../../assets/icons/challenge-picture-stack.svg';
import CashBagIcon from '../../../assets/icons/challenge-cash-bag.svg';
import { getChallengeDescription, getChallengeHeadline, getChallengeStats } from '../helpers/challengeCopy';
import styles from './ChallengeDetails.module.css';

type ChallengeDetailsProps = {
  applicationPage: ChallengeApplicationPage;
};

export default function ChallengeDetails({ applicationPage }: ChallengeDetailsProps) {
  const isMobile = useIsMobile();
  const { challenge, currency } = applicationPage;
  const isFreeProduct = challenge.reward.type === 'free_product';
  const stats = getChallengeStats(challenge, currency, isMobile);

  return (
    <div className={styles.hero}>
      <p className={styles.challengeName}>{challenge.name}</p>
      <div className={styles.challengeBlocks}>
        <div className={styles.heroCard}>
          <div className={styles.heroCardText}>
            <p className={styles.heroCardTitle}>{getChallengeHeadline(challenge, currency)}</p>
            <p className={styles.heroCardDescription}>{getChallengeDescription(applicationPage)}</p>
          </div>
          <img
            src={isFreeProduct ? CashBagIcon : PictureStackIcon}
            alt=""
            className={`${styles.heroCardIcon} ${isFreeProduct ? styles.cashBagIcon : ''}`}
          />
        </div>
        <div className={styles.statStrip}>
          {stats.map((stat, index) => (
            <Fragment key={stat.label}>
              {index > 0 && <div className={styles.statDivider} />}
              <div className={styles.stat}>
                <p className={styles.statValue}>{stat.value}</p>
                <p className={styles.statLabel}>{stat.label}</p>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
